import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, FormControl, FormGroup, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ProtuneApiService } from '../../../services/protune-api.service';
import { Router } from '@angular/router';
import { AuthService, AppSubscription } from '../../../services/auth.service';
import { SubscriptionLevels } from '../../../models/subscription-levels';
import moment from 'moment';

@Component({
  selector: 'app-subscription-update',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './subscription-update.component.html',
  styleUrl: './subscription-update.component.scss'
})
export class SubscriptionUpdateComponent implements OnInit {

  subscriptionUpdateForm: FormGroup;
  subscription: AppSubscription;
  isExpired: boolean = false;
  submitted: boolean = false;
  selectedSubscriptionLevel: string = '';
  advancedWithAIEngineer: boolean = false;
  liteWithAIEngineer: boolean = false;
  isAIEngineerSubscriptionExpired: boolean = true;
  products: any[];
  includeAIEngineerLite: boolean;
  includeAIEngineerAdvanced: boolean;

  constructor(private protuneApiService: ProtuneApiService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.authService.getSubscription().subscribe(subscription => {
      this.subscription = subscription;

      if (this.subscription.aiEngineerSubscriptionExpiration != null) {
        this.isAIEngineerSubscriptionExpired = moment().isAfter(this.subscription.aiEngineerSubscriptionExpiration);
      }

      console.log(this.subscription);

      this.isExpired = moment().isAfter(this.subscription.subscriptionExpiration);
      console.log(this.isExpired);
    });

    this.protuneApiService.getProducts()
      .subscribe(products => {
        this.products = products;
      });
  }

  updateSubscription(product: string) {
    //this.selectedSubscriptionLevel = subscriptionLevel;
    var products = [product];

    if (this.includeAIEngineerLite || this.includeAIEngineerAdvanced) {
      products.push(SubscriptionLevels.AIEngineer);
    }

    this.submitted = true;
    this.protuneApiService
      .getPaymentLink(products)
      .subscribe({
        next: (res: any) => {
          if (res) {
            window.location.href = res.url;
          }
          else {
            this.router.navigateByUrl('/');
          }
        },
        error: err => {
          this.submitted = false;
          //this.selectedSubscriptionLevel = '';
        }
      });
  }

  getProductPrice(key: string) {
    let products = this.products.filter(p => p.key == key);
    return products[0].price.toString() ?? '';
  }
}
